import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadRulesByIdFailed, loadRulesByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { normalizeRuleMessageForForm } from '../../../dto/RulesDTO';

export default function* loadRulesById(action) {
  try {
    const url = `${BACKEND_URL}/rules/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      const { rule } = data;
      if (rule) {
        rule.message = normalizeRuleMessageForForm(rule.message);
      }

      yield put(loadRulesByIdSuccessful(rule));
      yield call(resolveActionPromise(action, rule));
    } else {
      yield put(loadRulesByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadRulesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
